/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react';
import { useGlobalContext } from '../../context/GlobalContext';
import { ITrilhaFullDTO, IUnidade, IUnidadeCleanDTO, IUnidadeDTO } from '../../models/happy-code-api.model';
import { Predicate } from '../../models/predicate.model';
import { useTrilhaService } from '../../services/trilha.service';
import { useUnidadeService } from '../../services/unidade.service';
import buildUserAccessPredicate from '../../hooks/use-build-user-acess.hook';
import { getLocalStorageItem } from '../../util/store';
import { Operators } from '../../enum/operators.enum';

const useCursos = () => {
  const { setIsGlobalLoading, usuario, unidade } = useGlobalContext();

  const predicate = new Predicate();

  const trilhaService = useTrilhaService();
  const unidadeService = useUnidadeService();

  const [destaques, setDestaques] = useState<ITrilhaFullDTO[]>();


  const findUnidade = useCallback(async () => {
    if (unidade?.id) {
    setIsGlobalLoading(true);
      await unidadeService
        .findById({ id: unidade.id })
        .then(({ data }) => {
          findCursos(data);
        })
        .catch(() => setIsGlobalLoading(false));
    }
    findCursos(null);
  }, [unidade]);
  const findCursos = useCallback(async (unidadeDto: IUnidadeDTO) => {    
    predicate.addOption('ativo', true);

   const { unidadeTipoUnidadeCodigo } = getLocalStorageItem("@HappyCodeAcademy/login/unidade") as IUnidadeCleanDTO;
    if(unidadeDto?.id){
      if(unidadeTipoUnidadeCodigo.toLowerCase() !== 'angola' && unidadeTipoUnidadeCodigo.toLowerCase() !== 'paraguai'){
        predicate.addOption('tipoUnidade.id', unidadeDto?.tipoUnidade?.id)
      }
      else{
          predicate.addMultiOption('tipoUnidade.id', 1, Operators.OR);
          predicate.addMultiOption('tipoUnidade.id', 3, Operators.OR);
      }

    }
    const buildedPredicate = buildUserAccessPredicate(
      usuario,
      predicate
    );
    
    await trilhaService
      .findDestaques(
        buildedPredicate,
      )
      .then(({ data }) => setDestaques(data))
      .finally(() => setIsGlobalLoading(false));
  }, [
    setIsGlobalLoading,
    usuario?.acessoB2b,
    usuario?.acessoB2c,
    usuario?.acessoComercial,
  ]);

  useEffect(() => {
      findUnidade();
  }, [findUnidade, unidade]);

  return {
    destaques,
  };
};

export default useCursos;
